// extracted by mini-css-extract-plugin
export default {"container":"PlaygroundChat-module__container--qZPLy","header":"PlaygroundChat-module__header--hUzwJ","edit":"PlaygroundChat-module__edit--J96O0"};